import { render, staticRenderFns } from "./AttachmentPlaceholder.vue?vue&type=template&id=f5dc21ca&scoped=true&"
import script from "./AttachmentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AttachmentPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPlaceholder.vue?vue&type=style&index=0&id=f5dc21ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dc21ca",
  null
  
)

export default component.exports